/**
 * @description 參數類型 (enum)
 */
export enum SystemParamTypesEnum {
  /** 全部 */
  All = 'ALL',
  /** Base URL */
  BaseURL = 'BaseUrl',
  /** 計算時間 */
  CalculateTime = 'CalculateTime',
  /** 旅遊天數限制 */
  TravelDaysLimit = 'TravelDaysLimit'
}
